/**
 * plugins/vuetify.ts
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
import "@mdi/font/css/materialdesignicons.css"
import "vuetify/styles"
import "@/styles/colors.scss"
import { VDateInput } from "vuetify/labs/VDateInput"
import DayJsAdapter   from "@date-io/dayjs"
import dayjs          from "dayjs"
import "dayjs/locale/de"

// Composables
import { createVuetify } from "vuetify"
import { de }            from "vuetify/locale"

dayjs.locale("de")
// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
  components: {
    VDateInput
  },
  theme: {
    defaultTheme: "light",
    themes: {
      light: {
        dark: false,
        colors: {
          primary: "#A20F31"
        }
      }
    }
  },
  locale: {
    locale: "de",
    messages: { de }
  },
  date: {
    adapter: DayJsAdapter,
    locale: { de: de }
  }
})
